export const LoanConditionTasksTableTestIds = {
  LOAN_CONDITION_SLA_GROUP_TABLE: 'loan-condition-sla-group.table',

  getTaskSlaInfoButtonId: taskId => `loan-condition-sla-group.task-${taskId}-info-button`,
};
